// shift-time.ts

export function calculateUpdatedTime(initialTime: string): string {
  if (initialTime == null) {
    return ""
  }
  const [hours, minutes] = initialTime.split(/[ :]/).slice(0, 2).map(Number);
  let updatedMinutes = minutes + 75;
  let updatedHours = hours;
  if (updatedMinutes >= 60) {
    updatedHours += Math.floor(updatedMinutes / 60);
    updatedMinutes %= 60;
  }
  const updatedTime = `${updatedHours.toString().padStart(2, "0")}:${updatedMinutes.toString().padStart(2, "0")}`;
  return updatedTime;
}
